<template>
  <f7-page>
    <a
      class="fixed right-0 m-5 rounded-full shadow-lg p-2 leading-3 bg-purple-500"
      @click.prevent="$f7router.back()"
    >
      <eva-icon
        name="close-outline"
        fill="#FFFFFF"
        width="32"
        height="32"
      />
    </a>
    <upload-form
      :showOptions="true"
      @batchSuccess="$f7router.back()"
    />
  </f7-page>
</template>

<script>
import UploadForm from '../components/uploadForm'
export default {
  components: {
    UploadForm,
  },

}
</script>
